import React, { CSSProperties } from 'react';
import Button from '../buttons/Button';
import { CallAgentBox, ShowPhoneNumber } from './PropertyPhoneNumberButton.style';

interface PropertyPhoneNumberButtonProps {
  containerStyle?: CSSProperties;
  onCallClick: (location: string) => void;
  onShowNumberClick: (location: string) => void;
  color?: string;
  fontColor?: string;
  location: string;
  useShortText: boolean;
  hoverTextColor?: string;
  hoverColor?: string;
  icon?: any;
  revealNumber?: string | null;
}

const PropertyPhoneNumberButton: React.FC<PropertyPhoneNumberButtonProps> = (props) => {
  return (
    <>
      <ShowPhoneNumber data-testid="showPhoneNumber">
        <Button
          containerStyle={props.containerStyle}
          color={props.color}
          fontColor={props.fontColor}
          onClick={() => {
            if (props.revealNumber) props.onCallClick(props.location);
            else props.onShowNumberClick(props.location);
          }}
          testID="showPhoneNumberButton"
          type="button"
          icon={!props.revealNumber && props.icon}
          iconColour={props.fontColor}
          hoverTextColor={props.revealNumber ? props.fontColor : props.hoverTextColor}
          iconHoverColour={props.hoverTextColor}
          hoverColor={props.revealNumber ? props.color : props.hoverColor}
        >
          {props.revealNumber || (props.useShortText ? 'Call' : 'Call the Agent')}
        </Button>
      </ShowPhoneNumber>

      <CallAgentBox>
        <Button
          containerStyle={props.containerStyle}
          onClick={() => props.onCallClick(props.location)}
          testID="callAgentButton"
          type="button"
          color={props.color}
          fontColor={props.fontColor}
        >
          {props.useShortText ? 'Call' : 'Call the Agent'}
        </Button>
      </CallAgentBox>
    </>
  );
};

export default PropertyPhoneNumberButton;
